// extracted by mini-css-extract-plugin
export default {"wrapper":"Advt_wrapper__85Irm","titleBlock":"Advt_titleBlock__aKde+","title":"Advt_title__95xwU","qrCode":"Advt_qrCode__BgNQZ"};